import { CtgSearchFilterType } from "@/components/business/CtgListContainer/ctgList.types";

export const CTG_LIST_EDITOR_INFO_FILTER: CtgSearchFilterType[] = [
  {
    key: "allEditorInfo",
    name: "All Editor",
    isAllInfo: true,
  },
  {
    key: "mcEditorNameInfo",
    name: "MC Editor",
    code: "S112",
    isAllInfo: false,
  },
  {
    key: "ftEditorNameInfo",
    name: "FT Editor",
    code: "S911",
    isAllInfo: false,
  },
];

export const CTG_LIST_EDITOR_INFO_FILTER_KEY = [
  "allEditorInfo",
  "mcEditorNameInfo",
  "ftEditorNameInfo",
] as const;
